export const MD_WIDTH = 12;
export const SM_WIDTH = 12;
export const XS_WIDTH = 2;
export const XXS_WIDTH = 1;
